module.exports = __webpack_public_path__ + "img/icon5.2101ccc6.svg";